module.exports = __webpack_public_path__ + "img/chevron-up.9ef82657.svg";